const data = [
  {
    id: 1,
    question: 'How long has CARTILTD been doing this for ?',
    answer: "We have more than 10 years of hands on experience",
  },
  {
    id: 2,
    question: 'Can CARTILTD help with the materials and cost estimation phase?',
    answer: "Yes, we estimate the costs and execution timeline for your project",
  },
  {
    id: 5,
    question: 'How do I know where to start my indoor renovation ?',
    answer: "We recommend starting from the room and work your way out",
  },
  {
    id: 4,
    question: 'What disruptions can I expect during a indoor renovation ?',
    answer: "We do our best to minimize disruptions in your home during renovations. However, it is difficult to anticipate how much disruption will be necessary until the project is underway",
  },
  {
    id: 3,
    question: 'How long does a indoor renovation typically take from start to finish ?',
    answer: "It depends on what is planned for your renovation. When you start working with us, we will provide you with a breakdown and timeline",
  },
  {
    id: 6,
    question: 'Do i have to buy my materials myself or do you include the materials in project cost ?',
    answer: "In either case, we will help getting materials at fair cost",
  },
]

export default data
